@if (!['requestedDate', 'returnRequestedDate'].includes(config.property)) {
  <h3>
    <fa-icon [icon]="(_state.airportDestination ? faPlaneDeparture : faPlaneArrival)"></fa-icon>
    {{ 'flight_details'|translate|ucFirst }}
  </h3>
}
<span class="wb-summary-name">
  <ng-container>
    {{ config.label | translate | ucFirst }}
    @if (config.required) {
      <span class="wb-required">*</span>
    }
  </ng-container>

  @if (config.helpText && !summary) {
    <div class="wb-help"
      (click)="doToggleHelpText.emit({helpTitleTag: config.label,helpTextTag: getHelpText()})">
      <fa-icon [icon]="faInfoCircle"></fa-icon>
    </div>
  }
</span>

<div [formGroup]="control" class="wb-{{config.type}} {{opened ? 'wb-open' : ''}} {{hasErrors ? 'wb-error' : ''}}">
  <div
    class="wb-select {{!hasOptions ? 'hidden-select' : ''}}">
    <select (change)="changeMode($event)" name="{{config.property}}-selector">
      @if ((orderMode !== 'airport' || this.airportDates === 'optional')) {
        <option value="requestedDate">
          {{ 'pick_up' | translate | ucFirst }}
        </option>
      }

      @if (((orderMode === 'airport' && ((!isReturnTrip && _state.airportDestination) || (isReturnTrip && _state.airportDeparture)))) && (!_state.airportDeparture || (isReturnTrip && !_state.airportDestination)) ) {
        <option value="requestedDestinationDate"
          [selected]="(config.property === 'requestedDestinationDate' || config.property === 'returnRequestedDestinationDate')"
          >
          {{ 'drop_off' | translate | ucFirst }}
        </option>
      }

      @if ((orderMode === 'airport' && (!isReturnTrip && (_state.airportDeparture) || (isReturnTrip && _state.airportDestination)))) {
        <option value="requestedScheduleDate"
          [selected]="(config.property === 'requestedScheduleDate' || config.property === 'returnRequestedScheduleDate')"
          >
          {{ 'scheduled_pick_up' | translate | ucFirst }}
        </option>
      }
    </select>

    @if (!config.options.pickUpOnly &&
      !(config.property === 'returnRequestedDate' && orderMode === 'airport' && _state.airportDestination) &&
      !(config.property === 'requestedDate' && orderMode === 'airport' && _state.airportDeparture)) {
      <svg width="14px" height="10px" viewBox="0 0 14 10" version="1.1" xmlns="http://www.w3.org/2000/svg"
        >
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Book-your-trip" transform="translate(-108.000000, -498.000000)" fill="#FFFFFF">
            <polygon id="Triangle"
              transform="translate(115.000000, 503.000000) rotate(-180.000000) translate(-115.000000, -503.000000) "
            points="115 498 122 508 108 508"></polygon>
          </g>
        </g>
      </svg>
    }
  </div>
  <div class="wb-inputs {{(!hasOptions ? 'full-width' : 'wb-has-select')}}">
    <div class="flatpickr {{(_state.companySettings.clock === '12' ? 'clock-date' : '')}}">
      <ng2-flatpickr #picker [config]="options2">
        <button type="button" class="input-button" title="toggle" data-toggle>
          <mat-icon>today</mat-icon>
        </button>
      </ng2-flatpickr>
      <div class="time-selection {{(_state.companySettings.clock == '12'? 'am-clock' : 'default-clock')}}">
        <div class="wb-select-wrapper">
          <span class="selected-display">
            {{ selectedTime.split(':')[0] | displayHour:_state.companySettings.clock }}
          </span>
          <select
            class="desktop-timePicker mobile-time-picker text-center hour-picker real-select"
            (change)="onChangeTime($event)"
            name="hours">
            @for (time of timeHourOptions; track time) {
              <option
                [value]="time.value"
                [selected]="time.value === selectedTime.split(':')[0]"
                [disabled]="!time.enabled">
                {{ _state.companySettings.clock === '12' ? time.text : time.value }}
              </option>
            }
          </select>
        </div>

        <div class="seperator">:</div>
        <select class="desktop-timePicker mobile-time-picker text-center"
          (change)="onChangeTime($event)"
          name="minutes">
          @for (time of timeMinutesOptions; track time) {
            <option
              [value]="time.value"
              [selected]="time.value === selectedTime.split(':')[1]"
              [disabled]="!time.enabled">
              {{ time.value }}
            </option>
          }
        </select>
      </div>
    </div>
  </div>

  @if (configRequestedDestinationDateOffset > 0 && _state.airportDestination && !['requestedDate','returnRequestedDate'].includes(config.property)) {
    <div
      class="wb-airport-destination-text wb-help">
      <fa-icon [icon]="faInfoCircle"></fa-icon>
      {{ 'destination_offset_text_1'|translate|ucFirst }} {{ Math.floor(configRequestedDestinationDateOffset / 60) }} {{ 'hours'|translate }}
      @if ((configRequestedDestinationDateOffset % 60) > 0) {
        <span
          >{{ (configRequestedDestinationDateOffset % 60) }} {{ 'min'|translate }}
        .</span>
      }
      {{ 'destination_offset_text_2'|translate }}
    </div>
  }
</div>
<app-field-error [config]="config" (validityChanged)="validityChanged($event)"></app-field-error>
